import React from "react";
import Star from "../../assets/Star.png";
import Quotation from "../../assets/quotation-marks.png";

const ReviewCard = ({ object, padding }) => {
  const rating = Math.min(5, Math.max(0, Number(object.rating) || 0));
  const profileImage =
    object?.user?.profilePicture?.secureUrl ||
    object?.user?.profilePicture ||
    "";
  const firstName = object?.user?.firstName || "Student";
  const lastName = object?.user?.lastName || "";

  return (
    <div className="relative min-w-0">
      <div
        className={`rounded-[14px] bg-white pb-8 pr-3 pt-10 shadow-[0px_0px_9.8px_1px_rgba(0,0,0,0.25)] sm:rounded-[18px] sm:pb-9 sm:pr-4 sm:pt-12 md:pb-12 md:pt-20 2xl:pb-[55px] 2xl:pt-[90px] ${padding}`}
      >
        <div className="flex gap-1.5 sm:gap-2">
          {Array.from({ length: 5 }).map((_, idx) => (
            <img
              key={idx}
              src={Star}
              alt=""
              className={`h-5 w-5 sm:h-[26px] sm:w-7 ${
                idx < rating ? "opacity-100" : "opacity-25"
              }`}
            />
          ))}
        </div>
        <p className="mt-4 text-sm leading-5 sm:mt-6 sm:text-base xl:max-w-[320px]">
          {object.feedbackText}
        </p>
        <div className="mt-5 flex items-center gap-3 sm:mt-6 sm:gap-4 md:gap-6">
          {profileImage ? (
            <img
              src={profileImage}
              alt="profile picture"
              className="h-14 w-14 shrink-0 rounded-full object-cover sm:h-20 sm:w-20 md:h-24 md:w-24 2xl:h-[112px] 2xl:w-[114px]"
            />
          ) : (
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#FF6636]/10 text-sm font-semibold text-[#FF6636] sm:h-20 sm:w-20 sm:text-base md:h-24 md:w-24 2xl:h-[112px] 2xl:w-[114px] 2xl:text-lg">
              {firstName[0]}
              {lastName[0] || ""}
            </div>
          )}
          <div className="min-w-0">
            <h3 className="text-base font-bold leading-snug sm:text-xl sm:leading-[23px]">
              {firstName} {lastName}
            </h3>
            {/* <p className="mt-1 max-w-full text-sm leading-5 sm:max-w-[170px] sm:leading-[22px]">
              {object.designation}
            </p> */}
          </div>
        </div>
      </div>
      <div className="absolute -top-5 left-5 flex h-10 w-10 items-center justify-center rounded-full bg-[#FF6636] sm:-top-7 sm:left-8 sm:h-12 sm:w-12 md:-top-[35px] md:left-12 md:h-[70px] md:w-[70px]">
        <img
          src={Quotation}
          alt=""
          className="h-4 w-5 sm:h-5 sm:w-6 md:h-[30px] md:w-[33px]"
        />
      </div>
    </div>
  );
};

export default ReviewCard;
